import React from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const TooManyUsersDialog = observer(() => {
    const {modalStore, generalStore} = useStores();
    

    function closeModal() {
        modalStore.isTooManyUsersModalOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isTooManyUsersModalOpen'
            className='blue-dialog domain-expired-modal'
            title={generalStore.translate('tooManyUsersInThisWorkspace')}
            body={
                <div>
                    {generalStore.translate('itSeemsThatYourWorkspaceReachedItsUsersLimit')}.<br/> {generalStore.translate('ifYouWantToAddMoreUsersPlease')}
                    <a href='mailto:support@frontline.io' target='_blank' rel='noreferrer'>{generalStore.translate('sendUsAMessage')}</a>
                </div>
            }
            confirmText={generalStore.translate('gotIt')}
            onConfirm={closeModal}
            noCancel
        />
    );
});

export default TooManyUsersDialog;
